var map = {
	"./Carousel/1.jpg": 672,
	"./Carousel/2.jpg": 673,
	"./Carousel/3.jpg": 674,
	"./avtar/11.jpg": 675,
	"./avtar/16.jpg": 676,
	"./avtar/3.jpg": 677,
	"./banner/1.jpg": 678,
	"./banner/2.jpg": 679,
	"./banner/3.jpg": 680,
	"./bcci_logo.png": 681,
	"./big-lightgallry/01.jpg": 682,
	"./big-lightgallry/011.jpg": 683,
	"./big-lightgallry/012.jpg": 684,
	"./big-lightgallry/013.jpg": 685,
	"./big-lightgallry/014.jpg": 686,
	"./big-lightgallry/015.jpg": 687,
	"./big-lightgallry/016.jpg": 688,
	"./big-lightgallry/02.jpg": 689,
	"./big-lightgallry/03.jpg": 690,
	"./big-lightgallry/04.jpg": 691,
	"./big-lightgallry/05.jpg": 692,
	"./big-lightgallry/06.jpg": 693,
	"./big-lightgallry/07.jpg": 694,
	"./big-lightgallry/08.jpg": 695,
	"./blog/12.png": 696,
	"./blog/14.png": 697,
	"./blog/4.jpg": 698,
	"./blog/9.jpg": 699,
	"./blog/blog-2.jpg": 700,
	"./blog/blog-3.jpg": 701,
	"./blog/blog-4.jpg": 702,
	"./blog/blog-5.jpg": 703,
	"./blog/blog-5.png": 704,
	"./blog/blog-6.jpg": 705,
	"./blog/blog-6.png": 706,
	"./blog/blog-single.jpg": 707,
	"./blog/blog.jpg": 708,
	"./blog/comment.jpg": 709,
	"./blog/img.png": 710,
	"./cloud.png": 711,
	"./color-picker.png": 712,
	"./cursor.png": 713,
	"./customize.png": 714,
	"./dashboard-ecommerce/1.png": 715,
	"./dashboard-ecommerce/2.png": 716,
	"./dashboard-ecommerce/3.png": 717,
	"./dashboard-ecommerce/4.png": 718,
	"./dashboard-ecommerce/watch.png": 719,
	"./dashboard/bg.jpg": 720,
	"./dashboard/bookmark.png": 721,
	"./dashboard/chat.png": 722,
	"./dashboard/clipboard.png": 723,
	"./dashboard/greeting.png": 724,
	"./dashboard/like.png": 725,
	"./dashboard/mobile.png": 726,
	"./dashboard/music.png": 727,
	"./dashboard/notification.png": 728,
	"./dashboard/pc.png": 729,
	"./dashboard/popup.png": 730,
	"./dashboard/profile-1.png": 731,
	"./dashboard/profile.png": 119,
	"./dashboard/profile_sm.png": 732,
	"./dashboard/recent-user-1.png": 733,
	"./dashboard/recent-user-2.png": 734,
	"./dashboard/recent-user-3.png": 735,
	"./dashboard/recent-user-4.png": 736,
	"./dashboard/tab.png": 737,
	"./dashboard/user.png": 738,
	"./dashboard/wallet.png": 739,
	"./dashboard/weather-image.png": 740,
	"./dashboard/whather_bg.jpg": 741,
	"./dashboard/whether.png": 742,
	"./ecommerce/01.jpg": 743,
	"./ecommerce/02.jpg": 744,
	"./ecommerce/03.jpg": 745,
	"./ecommerce/04.jpg": 746,
	"./ecommerce/05.jpg": 747,
	"./ecommerce/06.jpg": 748,
	"./ecommerce/07.jpg": 749,
	"./ecommerce/08.jpg": 750,
	"./ecommerce/09.jpg": 751,
	"./ecommerce/10.jpg": 752,
	"./ecommerce/11.jpg": 753,
	"./ecommerce/12.jpg": 754,
	"./ecommerce/card.png": 755,
	"./ecommerce/mastercard.png": 756,
	"./ecommerce/paypal.png": 757,
	"./ecommerce/product-table-1.png": 758,
	"./ecommerce/product-table-2.png": 759,
	"./ecommerce/product-table-3.png": 760,
	"./ecommerce/product-table-4.png": 761,
	"./ecommerce/product-table-5.png": 762,
	"./ecommerce/product-table-6.png": 763,
	"./ecommerce/visa.png": 764,
	"./email/1.jpg": 765,
	"./email/2.jpg": 766,
	"./email/3.jpg": 767,
	"./faq/1.jpg": 768,
	"./faq/2.jpg": 769,
	"./faq/3.jpg": 770,
	"./faq/4.jpg": 771,
	"./faq/learning-1.png": 772,
	"./job-search/1.jpg": 773,
	"./job-search/2.jpg": 774,
	"./job-search/3.jpg": 775,
	"./job-search/4.jpg": 776,
	"./job-search/5.jpg": 777,
	"./job-search/6.jpg": 778,
	"./lightgallry/01.jpg": 779,
	"./lightgallry/010.jpg": 780,
	"./lightgallry/011.jpg": 781,
	"./lightgallry/012.jpg": 782,
	"./lightgallry/013.jpg": 783,
	"./lightgallry/014.jpg": 784,
	"./lightgallry/015.jpg": 785,
	"./lightgallry/016.jpg": 786,
	"./lightgallry/02.jpg": 787,
	"./lightgallry/03.jpg": 788,
	"./lightgallry/04.jpg": 789,
	"./lightgallry/05.jpg": 790,
	"./lightgallry/06.jpg": 791,
	"./lightgallry/07.jpg": 792,
	"./lightgallry/08.jpg": 793,
	"./lightgallry/09.jpg": 794,
	"./logo/Vantr-v.png": 795,
	"./logo/logo-1.png": 796,
	"./logo/logo-2.png": 797,
	"./logo/logo.png": 798,
	"./logo/shree-logo.png": 211,
	"./masonry/1.jpg": 799,
	"./masonry/10.jpg": 800,
	"./masonry/11.jpg": 801,
	"./masonry/12.jpg": 802,
	"./masonry/13.jpg": 803,
	"./masonry/14.jpg": 804,
	"./masonry/15.jpg": 805,
	"./masonry/2.jpg": 806,
	"./masonry/3.jpg": 807,
	"./masonry/4.jpg": 808,
	"./masonry/5.jpg": 809,
	"./masonry/7.jpg": 810,
	"./masonry/8.jpg": 811,
	"./masonry/9.jpg": 812,
	"./other-images/auth-bg-1.jpg": 813,
	"./other-images/bg-profile.png": 814,
	"./other-images/coming-soon-bg.jpg": 815,
	"./other-images/login-bg-2.jpg": 816,
	"./other-images/login-bg.jpg": 817,
	"./other-images/maintenance-bg.jpg": 818,
	"./other-images/mobile-clock-wallpaper.jpg": 819,
	"./other-images/paypal.png": 820,
	"./other-images/profile-style-img.png": 821,
	"./other-images/profile-style-img2.png": 822,
	"./other-images/profile-style-img3.png": 823,
	"./other-images/sad.png": 824,
	"./product/1.png": 825,
	"./product/10.png": 826,
	"./product/11.png": 827,
	"./product/12.png": 828,
	"./product/13.png": 829,
	"./product/14.png": 830,
	"./product/15.png": 831,
	"./product/2.png": 832,
	"./product/3.png": 833,
	"./product/4.png": 834,
	"./search-not-found.png": 835,
	"./sidebar-image/1.jpg": 836,
	"./sidebar-image/2.jpg": 837,
	"./sidebar-image/3.jpg": 838,
	"./sidebar-image/4.jpg": 839,
	"./sidebar-image/5.jpg": 840,
	"./sidebar-image/6.jpg": 841,
	"./sidebar-pattern/1.png": 842,
	"./sidebar-pattern/2.png": 843,
	"./sidebar-pattern/3.png": 844,
	"./sidebar-pattern/4.png": 845,
	"./sidebar-pattern/5.png": 846,
	"./sidebar-pattern/6.png": 847,
	"./smiley.png": 848,
	"./social-app/post-1.png": 849,
	"./social-app/post-2.png": 850,
	"./social-app/post-3.png": 851,
	"./social-app/post-4.png": 852,
	"./social-app/post-5.png": 853,
	"./social-app/post-6.png": 854,
	"./social-app/post-7.png": 855,
	"./social-app/post-8.png": 856,
	"./social-app/post-9.png": 857,
	"./social-app/social-image.png": 858,
	"./social-app/timeline-1.png": 859,
	"./social-app/timeline-2.png": 860,
	"./social-app/timeline-3.png": 861,
	"./social-app/timeline-4.png": 862,
	"./start-conversion.jpg": 863,
	"./user-card/1.jpg": 864,
	"./user-card/2.jpg": 865,
	"./user-card/3.jpg": 866,
	"./user-card/5.jpg": 867,
	"./user-card/6.jpg": 868,
	"./user-card/7.jpg": 869,
	"./user/1.jpg": 870,
	"./user/10.jpg": 871,
	"./user/11.jpg": 872,
	"./user/11.png": 873,
	"./user/110.jpg": 874,
	"./user/12.jpg": 875,
	"./user/120.jpg": 876,
	"./user/14.jpg": 877,
	"./user/15.jpg": 878,
	"./user/15.png": 879,
	"./user/16.jpg": 880,
	"./user/16.png": 881,
	"./user/2.jpg": 882,
	"./user/2.png": 883,
	"./user/22.jpg": 884,
	"./user/3.jpg": 885,
	"./user/3.png": 886,
	"./user/33.jpg": 887,
	"./user/4.jpg": 888,
	"./user/5.jpg": 889,
	"./user/6.jpg": 890,
	"./user/7.jpg": 891,
	"./user/8.jpg": 892,
	"./user/9.jpg": 893,
	"./user/user.jpg": 894,
	"./user/user.png": 895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;